export const COOKIE_KEYS = {
  USER_STORE: "user",
} as const;

export type UserSpace = "auditor" | "city" | "user" | null;

export interface UserStoreCookie {
  selectedSpace?: UserSpace;
}
